import React from "react";
import classes from "../styles/button.module.css";
function CustomizedButton({
  btnText
}) {
  return <div className={classes.btnContainer} data-sentry-component="CustomizedButton" data-sentry-source-file="button.jsx">
      <button className={classes.btnText}>
        {btnText}
      </button>
    </div>;
}
export default CustomizedButton;